export const tableColumn = [
	{
		label: '序号',
		width: '120px',
		isCustomize: true,
		tableType: 'no',
	},
	{
		label: '渠道名',
		prop: 'channelName',

	},
	{
		label: '用户名',
		prop: 'nickname',

	},
	{
		label: '开启接收(当前渠道)',
		prop: 'enabled',
		tableType: 'switchType',
		isCustomize: true,
	},
	{
		label: '数量',
		prop: 'maxNum',
		isCustomize: true,
		tableType: 'tInput',
	},
	{
		label: '接收顺序（优先级）',
		prop: 'order',
		isCustomize: true,
		tableType: 'tInput',
	},
	{
		label: '操作',
		prop: 'id',
		width: '100px',
		isCustomize: true,
		tableType: 'channelRuleBtn',
		fixed: 'right',
	},
]

export const filters = [
	[
		{
			label: '来源渠道',
			type: 'select',
			attr: 'channelId',
			placeholder: '请选择',
			column: 6,
			option: [{ label: '系统分配', val: 1 }],
			labelWidth: '74px',
		},
		{
			type: 'button',
			column: 6,
		},
	],
]
